import DiscoTableSortDropdown, {
  DiscoTableSortDirection,
  DiscoTableSortOption,
  DiscoTableToolbarStateWithSort,
} from "@disco-ui/table/header/search/DiscoTableSortDropdown"
import { TestIDProps } from "@utils/typeUtils"

export interface AdminMembersReportEventsTableSortDropdownProps extends TestIDProps {
  sortState: DiscoTableToolbarStateWithSort
  setSortState: (state: DiscoTableToolbarStateWithSort) => void
  additionalSortOptions?: DiscoTableSortOption[]
}

function AdminMembersReportEventsTableSortDropdown({
  sortState,
  setSortState,
}: AdminMembersReportEventsTableSortDropdownProps) {
  const SORT_OPTIONS: DiscoTableSortOption[] = [
    {
      value: "start_date",
      title: "Start Date",
      context: {
        order: { field: "start_date" },
      },
    },
    {
      value: "event_name",
      title: "Event Name",
      context: {
        order: { field: "event_name" },
      },
    },
    {
      value: "feedback",
      title: "Feedback",
      context: {
        order: { field: "feedback" },
      },
    },
    {
      value: "recording_watch_progress",
      title: "Watch Progress",
      context: {
        order: { field: "recording_watch_progress" },
      },
    },
  ]

  return (
    <DiscoTableSortDropdown
      testid={"AdminMembersReportEventsTableSortDropdown"}
      options={SORT_OPTIONS}
      onOptionSelect={handleSortSelect}
      toolbarState={sortState}
    />
  )

  function handleSortSelect(
    sortOption: DiscoTableSortOption,
    direction: DiscoTableSortDirection
  ) {
    setSortState({
      search: sortState.search,
      sort: {
        id: sortOption.value,
        order: sortOption.context!.order,
        title: sortOption.title,
      },
      direction,
    })
  }
}

export default AdminMembersReportEventsTableSortDropdown
